import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const CrossCircleFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.00008 0.666687C2.50008 0.666687 0.666748 4.33335 0.666748 8.00002C0.666748 11.6667 2.50008 15.3334 8.00008 15.3334C13.5001 15.3334 15.3334 11.6667 15.3334 8.00002C15.3334 4.33335 13.5001 0.666687 8.00008 0.666687ZM5.75771 11.0909L8.00011 8.84849L10.2425 11.0909L11.091 10.2424L8.84864 7.99996L11.091 5.75756L10.2425 4.90904L8.00011 7.15144L5.75772 4.90904L4.90919 5.75756L7.15158 7.99996L4.90918 10.2424L5.75771 11.0909Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const CrossCircleFilledSize16 = hoc(forwardRef(CrossCircleFilledSize16Component), 'CrossCircleFilledSize16');

export { CrossCircleFilledSize16 as default };
//# sourceMappingURL=CrossCircleFilledSize16.js.map
